import { render } from "./noticeTool.vue?vue&type=template&id=2f47a1b5&scoped=true"
const script = {}

import "./noticeTool.vue?vue&type=style&index=0&id=2f47a1b5&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f47a1b5"]])

export default __exports__